import { render } from "./ConfirmSubscription.vue?vue&type=template&id=07bd666d&scoped=true"
import script from "./ConfirmSubscription.vue?vue&type=script&lang=js"
export * from "./ConfirmSubscription.vue?vue&type=script&lang=js"

import "./ConfirmSubscription.vue?vue&type=style&index=0&id=07bd666d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bd666d"]])

export default __exports__